<button
  type="button"
  class="map-popover__toggle"
  [class.map-popover__toggle--highlighted]="highlighted()"
  [class.map-popover__toggle--open]="expanded()"
  [attr.aria-expanded]="expanded()"
  [title]="buttonTitle()"
  (click)="toggleExpanded()"
>
  <svg-icon [src]="icon()"></svg-icon>
</button>

@if (expanded()) {
  <div class="map-popover__panel" [class.map-popover__panel--bottom]="attach() === 'bottom'">
    <ng-content></ng-content>
  </div>
}
